import React from 'react';
import {
    Search, X, Code, PenTool, Layout, Box, Globe, Cpu, Smartphone, Server, Database, Terminal,
    Settings, Wrench, Hammer, Palette, Image, Layers, Crop, FileCode, Archive, Package,
    Zap, Activity, Grid, Home, Folder, File, Mic, Video, Camera, Music, Headphones, Speaker,
    Bell, Mail, MessageSquare, Calendar, Clock, MapPin, Navigation, Compass, Sun, Moon, Cloud,
    Monitor, Tablet, Printer, Wifi, Bluetooth, Battery, Shield, Lock, Unlock, Key,
    User, Users, Star, Heart, ThumbsUp, Eye, Share, Download, Upload, Trash2, Edit2, Plus, Minus
} from 'lucide-react';

// Icon Map
export const ALL_ICONS: Record<string, React.ElementType> = {
    // Development
    Code, Terminal, Database, Server, Cpu, Globe, Smartphone, Monitor, Tablet, FileCode,
    // Design
    PenTool, Palette, Layout, Layers, Image, Crop, Grid, Box, Package, Archive,
    // Tools
    Settings, Wrench, Hammer, Zap, Activity, Search, Bell, Mail, MessageSquare, Calendar, Clock,
    // Media & Hardware
    Mic, Video, Camera, Music, Headphones, Speaker, Printer, Wifi, Bluetooth, Battery,
    // Status & Misc
    Home, Folder, File, MapPin, Navigation, Compass, Sun, Moon, Cloud, Shield, Lock, Unlock, Key,
    User, Users, Star, Heart, ThumbsUp, Eye, Share, Download, Upload, Trash2, Edit2, Plus, Minus
};
